"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Text = exports.Root = exports.LinkArrow = exports.ImageWrapper = exports.ContentWrapper = exports.CatalogueTitle = exports.CatalogueDateRange = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('a', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  type
}) => ({
  color: theme.palette.text.primary,
  backgroundColor: type === 'quiz' ? theme.palette.grey[100] : theme.palette.common.white,
  borderRadius: 10,
  boxShadow: type === 'quiz' ? undefined : theme.shadows[2],
  cursor: 'pointer',
  display: 'flex',
  overflow: 'hidden',
  position: 'relative',
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.text.primary,
    backgroundColor: type === 'quiz' ? theme.palette.grey[200] : theme.palette.common.white,
    boxShadow: type === 'quiz' ? undefined : theme.shadows[3]
  },
  '&:focus': {
    color: theme.palette.text.primary,
    outline: type === 'quiz' ? `1px solid ${theme.palette.default.dark}` : undefined
  },
  width: '100%',
  pointerEvents: 'all',
  maxWidth: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 'min(100%, 600px)',
    width: 'max-content'
  },
  height: 103
}));
const LinkArrow = exports.LinkArrow = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  marginLeft: 'auto',
  marginRight: theme.spacing(2),
  pointerEvents: 'none',
  svg: {
    fontSize: '2rem'
  }
}));
const ContentWrapper = exports.ContentWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignSelf: 'center',
  padding: theme.spacing(4, 3),
  pointerEvents: 'none'
}));
const Title = exports.Title = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  maxLines = 0
}) => ({
  fontSize: '1rem',
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: '3px',
  marginBottom: theme.spacing(1),
  textTransform: 'uppercase',
  pointerEvents: 'none',
  display: maxLines > 0 ? '-webkit-box' : undefined,
  overflow: maxLines > 0 ? 'hidden' : undefined,
  WebkitBoxOrient: maxLines > 0 ? 'vertical' : undefined,
  WebkitLineClamp: maxLines
}));
const Text = exports.Text = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['maxLines'])
})(({
  theme,
  maxLines = 0
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  display: maxLines > 0 ? '-webkit-box' : undefined,
  overflow: maxLines > 0 ? 'hidden' : undefined,
  WebkitBoxOrient: maxLines > 0 ? 'vertical' : undefined,
  WebkitLineClamp: maxLines,
  pointerEvents: 'none'
}));
const CatalogueDateRange = exports.CatalogueDateRange = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
  textTransform: 'uppercase',
  pointerEvents: 'none'
}));
const CatalogueTitle = exports.CatalogueTitle = (0, _mui.styled)(_mui.Typography)(() => ({
  pointerEvents: 'none'
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  imageWidth,
  shouldWidthBeLarger
}) => ({
  minWidth: `${imageWidth}px`,
  overflow: 'hidden',
  position: 'relative',
  width: `${imageWidth}px`,
  img: {
    height: shouldWidthBeLarger ? 'unset' : '100%',
    left: shouldWidthBeLarger ? 'unset' : '50%',
    position: 'absolute',
    top: shouldWidthBeLarger ? '50%' : 'unset',
    transform: shouldWidthBeLarger ? 'translateY(-50%)' : 'translateX(-50%)',
    width: shouldWidthBeLarger ? '100%' : 'unset'
  },
  pointerEvents: 'none'
}));
